export default __webpack_public_path__ + "static/media/desert.a16b6135.mp3";